<div class="form-group">
    <textarea class="form-control"
              name="html"
              rows="4"
              cols="50"
              value="{{fieldOptions.html}}"
              [(ngModel)]="fieldOptions.html"></textarea>
</div>